import { Space, Typography } from "antd"
import SmallProfileCard from "../../../components/ContactInfo/SmallProfileCard"
import MasterComponent from "../../../components/Forms"
import { constants } from "../../../constants/common"
import { MasterConfigs } from "../../../interfaces/entity"
import moment from "moment"
const { Text } = Typography

const EmployeeAccountsManagement = () => {
    const config: MasterConfigs = {
        api: () => '/employee-account-management',
        isActionTab: true,
        getFormColumns: () => [
            {
                label: 'Employee',
                name: 'employee',
                type: 'select',
                isCombo: true,
                rules: [{ required: true, message: 'Please select an employee' }],
            },
            {
                label: 'Bank Name',
                name: 'bankName',
                type: 'text',
                rules: [{ required: true, message: 'Bank name is required' }],
            },
            {
                label: 'Branch Name',
                name: 'branchName',
                type: 'text',
                rules: [{ required: true, message: 'Branch name is required' }],
            },
            {
                label: 'Account Number',
                name: 'accountNumber',
                type: 'text',
                rules: [
                    { required: true, message: 'Account number is required' },
                    {
                        pattern: /^[0-9]{9,18}$/,
                        message: 'Enter a valid account number (9 to 18 digits)',
                    },
                ],
            },
            {
                label: 'Account Type',
                name: 'accountType',
                type: 'select',
                children: [
                    { name: 'Saving', value: 'saving' },
                    { name: 'Current', value: 'current' },
                    { name: 'Salary', value: 'salary' }
                ],
                rules: [
                    { required: true, message: 'Account type is required' },
                ],
            },
            {
                label: 'IFSC Code',
                name: 'ifscCode',
                type: 'text',
                rules: [
                    { required: true, message: 'IFSC code is required' },
                    {
                        pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                        message: 'Enter a valid IFSC code',
                    },
                ],
            },
            {
                label: 'PAN Number',
                name: 'panNumber',
                type: 'text',
                rules: [
                    { required: true, message: 'PAN number is required' },
                    {
                        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                        message: 'Enter a valid PAN number (e.g., ABCDE1234F)',
                    },
                ],
            },
            {
                label: 'UAN Number',
                name: 'uanNumber',
                type: 'text',
                rules: [
                    {
                        pattern: /^[0-9]{12}$/,
                        message: 'Enter a valid UAN number (12 digits)',
                    },
                ],
            }
        ],
        getColumns: () => [
            {
                title: 'Employee',
                dataIndex: 'employee',
                width: 200,
                fixed: 'left',
                render: (_, record) => <SmallProfileCard
                    name={constants.GET_FULL_NAME(_)}
                    avatar={_?.avatar}
                    subTitle={_?.employeeId}
                />
            },
            {
                title: 'Bank Name',
                dataIndex: 'bankName',
                align: 'center',
                width: 150
            },
            {
                title: 'Branch Name',
                dataIndex: 'branchName',
                align: 'center',
                width: 150,
            },
            {
                title: 'Account Number',
                dataIndex: 'accountNumber',
                align: 'center',
                width: 150,
            },
            {
                title: 'Account Type',
                dataIndex: 'accountType',
                align: 'center',
                width: 150,
            },
            {
                title: 'IFSC Code',
                dataIndex: 'ifscCode',
                width: 150,
            },
            {
                title: 'PAN Number',
                dataIndex: 'panNumber',
                width: 150,
            },
            {
                title: 'Created By',
                dataIndex: 'createdBy',
                width: 180,
                render: (_, record) => _ ? <SmallProfileCard
                    name={constants.GET_FULL_NAME(_)}
                    avatar={_?.avatar}
                    subTitle={_?.employeeId}
                /> : ''
            },
            {
                title: 'Updated By',
                dataIndex: 'updatedBy',
                width: 180,
                render: (_, record) => _ ? <SmallProfileCard
                    name={constants.GET_FULL_NAME(_)}
                    avatar={_?.avatar}
                    subTitle={_?.employeeId}
                /> : ''
            },
            {
                title: 'Created At',
                dataIndex: 'createdAt',
                align: 'center',
                width: 200,
                render: (_) => moment(_).format('lll')
            },
            {
                title: 'Updated At',
                dataIndex: 'updatedAt',
                align: 'center',
                width: 200,
                render: (_) => moment(_).format('lll')
            },
        ],
        combo: [
            {
                name: 'employee',
                api: '/users?enablePayroll=true',
                render: (e) => constants.GET_FULL_NAME(e),
                idKey: '_id'
            },
            {
                name: 'salary_structure',
                api: '/salary-structure-type',
                render: (e) => e.name,
                idKey: '_id'
            }
        ],
        actions: [{ name: 'Add', actionType: "Add" }]
    }

    return <MasterComponent config={config} />
}

export default EmployeeAccountsManagement 